<template>
  <span>{{ output }}</span>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "StoreCashbackPrice",
  props: {
    description: {
      required: true,
      type: String,
    },
    value: {
      required: true,
      type: String,
    },
  },
  computed: {
    ...mapGetters({
      chosenVariant: "variantPicker/chosenVariant",
      allProductVariants: "variantPicker/allProductVariants",
    }),
    variant() {
      return this.allProductVariants.find(variant => variant.id === this.chosenVariant);
    },
    output() {
      if (this.variant && this.calculatePrice(this.variant.price) > 0) {
        return this.description.replace(this.value, `${this.calculatePrice(this.variant.price)} €`);
      } else {
        return this.description;
      }
    },
  },
  methods: {
    calculatePrice(price) {
      return Math.round(price * parseFloat(this.value)) / 100;
    },
  },
};
</script>
